<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[26px] leading-[36px] text-gray-800 font-secondary font-[370] text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto mb-5">
        <span class="text-green-700 font-semibold">
          Dacr AI will inform you in realtime
        </span>
        when it discovers your work being used from across the internet.
      </div>

      <div class="mt-auto w-full">
        <TestimonialCard
          :quote="testimonial.quote"
          :author="testimonial.author"
          class="mb-[30px]"
        />

        <UiButton class="w-full" primary large @click="handleClick">
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import TestimonialCard from '@/shared/components/TestimonialCard.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import WillieAvatar from '@/assets/images/Willie-Avatar.jpg'
import { useOnboardingStore } from '@/features/onboarding/store'

const testimonial = {
  quote:
    'Artists need a good way to protect their work and this gives the power back to the creators',
  author: {
    avatarUrl: WillieAvatar,
    name: 'Willie Joe',
    title: 'Head of A&R, Generation Now',
  },
}

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({
    step: 10,
  })

  onboardingStore.goToNextStep()
}
</script>
